import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import { CALENDAR_VIEWS, flownectColors } from "../../const";
import dayjs from "dayjs";
import { colors } from "../../../../ui/colors";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

interface HeaderTitleProps {
  currentWeek: dayjs.Dayjs;
  viewType: string;
  onPrev: () => void;
  onNext: () => void;
}

export const HeaderTitle = ({ currentWeek, viewType, onPrev, onNext }: HeaderTitleProps) => {
  const tooltipLabels = {
    [CALENDAR_VIEWS.DAY]: { prev: "Previous Day", next: "Next Day" },
    [CALENDAR_VIEWS.MONTH]: { prev: "Previous Month", next: "Next Month" },
    [CALENDAR_VIEWS.LIST]: { prev: "Previous Week", next: "Next Week" },
  };

  const currentLabels = tooltipLabels[viewType] || tooltipLabels[CALENDAR_VIEWS.DAY];

  const getDynamicTitle = () => {
    switch (viewType) {
      case CALENDAR_VIEWS.DAY:
        return currentWeek.format("dddd D MMMM, YYYY");
      case CALENDAR_VIEWS.MONTH:
        return currentWeek.format("MMMM YYYY");
      case CALENDAR_VIEWS.LIST:
        const start = currentWeek.startOf("week").format("MMMM D");
        const end = currentWeek.endOf("week").format("D");
        return `${start} - ${end}, ${currentWeek.format("YYYY")}`;
      default:
        return currentWeek.format("MMMM D, YYYY");
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: 0.5, my: 3 }}>
      <Typography
        sx={{
          color: colors.orange.base,
          fontWeight: 800,
          textTransform: "uppercase",
          letterSpacing: "1.5px",
          fontSize: "0.65rem",
        }}
      >
        {viewType === CALENDAR_VIEWS.DAY ? "Day's Agenda" : viewType === CALENDAR_VIEWS.MONTH ? "Monthly Overview" : "Weekly Schedule"}
      </Typography>

      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 1 }}>
        <Tooltip title={currentLabels.prev} arrow slotProps={{ popper: { sx: { zIndex: 9999999 } } }}>
          <IconButton
            onClick={onPrev}
            size="small"
            sx={{
              borderRadius: "8px",
              border: `1px solid ${flownectColors.gray[200]}`,
              height: "32px",
              width: "32px",
              bgcolor: "var(--fx-surface-base, #FFFFFF)",
            }}
          >
            <ArrowBackIosIcon sx={{ fontSize: 10, ml: 0.5 }} />
          </IconButton>
        </Tooltip>

        <Box width={500} display={"flex"} alignContent={"center"} justifyContent={"center"}>
          <Typography
            sx={{
              color: "var(--fx-surface-textsecondary, #64748B)",
              fontWeight: 800,
              fontSize: 32,
              letterSpacing: "-1.5px",
              lineHeight: 1,
              fontFamily: "'Inter', 'Roboto', sans-serif",
              textTransform: "capitalize",
            }}
          >
            {getDynamicTitle()}
          </Typography>
        </Box>

        <Tooltip title={currentLabels.next} arrow slotProps={{ popper: { sx: { zIndex: 9999999 } } }}>
          <IconButton
            onClick={onNext}
            size="small"
            sx={{
              borderRadius: "8px",
              border: `1px solid ${flownectColors.gray[200]}`,
              height: "32px",
              width: "32px",
              bgcolor: "var(--fx-surface-base, #FFFFFF)",
            }}
          >
            <ArrowForwardIosIcon sx={{ fontSize: 10 }} />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};
